import { Button, Divider, Modal, notification, Typography, Tag } from 'antd'
import { ColumnProps } from 'antd/lib/table'
import Axios from 'axios'
import moment from 'moment'
import React, { Fragment, useCallback, useRef } from 'react'
import { titles } from '../../setup/messages'
import { IPaginatedListAPI } from '../list/models/IPaginatedListAPI'
import PaginatedList from '../list/PaginatedList'
import { IGiftTransfer } from './models/IGiftRequest'

const GiftRequestsPage: React.FC = () => {
  const endpoint = `/api/gifts/requests`
  const listRef = useRef<IPaginatedListAPI>(null)

  const setAsComplete = useCallback(async (id: string) => {

    try {
      await Axios.patch(`${endpoint}/${id}`, {
        isNewStatus: false
      })

      const { current } = listRef

      if (current) {
        current.refetchData()
      }

      notification.success({message: 'Xác nhận yêu cầu thành công'})

    } catch(error) {
      notification.error({message: 'xác nhận yêu cầu thất bại'})
    }
  }, [endpoint])

  const cancelGiftRequest = useCallback(async (id: string) => {
    try {
      await Axios.delete(`${endpoint}/${id}/cancel`);
      
      const { current } = listRef;
      if (current) {
        current.refetchData();
      }

      notification.success({
        message: 'Huỷ yêu cầu thành công',
        description: 'Kudos đã được hoàn lại cho người dùng'
      });
    } catch (error) {
      notification.error({
        message: 'Huỷ yêu cầu thất bại',
        description: 'Vui lòng thử lại'
      });
    }
  }, [endpoint]);

  const columns: Array<ColumnProps<IGiftTransfer>> = [
    {
      dataIndex: 'giftRequestDate',
      key: 'request-date',
      render: text => moment(text).format('lll'),
      title: 'Date',
    },
    {
      dataIndex: 'giftName',
      key: 'gift-name',
      title: 'Gift name'
    },
    {
      dataIndex: 'giftCost',
      key: 'gift-cost',
      title: 'Gift cost'
    },
    {
      dataIndex: 'userName',
      key: 'gift-receiver',
      title: 'Receiver nickname'
    },
    {
      key: 'status',
      render: ({ status }) => {
        let label, color;
        
        switch(status) {
          case 'CANCELLED':
            label = 'ĐÃ HỦY';
            color = 'red';
            break;
          case 'COMPLETED':
            label = 'HOÀN THÀNH';
            color = 'geekblue';
            break;
          case 'PENDING':
            label = 'CHỜ XỬ LÝ';
            color = 'orange';
            break;
          default:
            label = 'CHỜ XỬ LÝ';
            color = 'orange';
        }

        return (
          <Tag color={color}>
            {label}
          </Tag>
        )
      },
      title: 'Trạng thái'
    },
    {
      key: 'action',
      render: ({_id, status}) => {
        return (
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button
              disabled={status !== 'PENDING'}
              type="primary"
              onClick={() => Modal.confirm({
                onOk: () => setAsComplete(_id),
                title: `Xác nhận yêu cầu quà`,
                content: 'Bạn có chắc chắn muốn xác nhận yêu cầu này?',
                okText: 'Xác nhận',
                cancelText: 'Huỷ bỏ',
                okButtonProps: { type: 'primary' }
              })}
              size='small'
            >
              Xác nhận
            </Button>
            <Button
              disabled={status !== 'PENDING'}
              danger
              onClick={() => Modal.confirm({
                title: 'Huỷ yêu cầu quà',
                content: 'Bạn có chắc chắn muốn huỷ yêu cầu này? Kudos sẽ được hoàn lại cho người dùng.',
                okText: 'Xác nhận huỷ', 
                cancelText: 'Đóng',
                okButtonProps: { danger: true },
                onOk: () => cancelGiftRequest(_id)
              })}
              size='small'
            >
              Huỷ
            </Button>
          </div>
        )
      },
      title: 'Thao tác',
      width: '250px'
    }
  ]

  return (
    <Fragment>
      <Typography.Title level={2}>{titles.giftRequests}</Typography.Title>
      <Divider />
      <PaginatedList<IGiftTransfer>
        columns={columns}
        endpoint={endpoint}
        pageSize={10}
        getAPIRef={listRef}
      />
    </Fragment>
  )
}

export default GiftRequestsPage
